export default __webpack_public_path__ + "static/media/settings.a35cbcf1.png";